import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const PcBox = styled.div`
    width: 57%;
`;

const MobileBox = styled(PcBox)`
    width: 100%;

    @media ${({theme}) => `${theme.mediaQuery.landscape}`} {
        width: 57%;
    }
`;

export const PaymentRedirectButtonContainerBox = styledByDevice(PcBox, MobileBox);